import { useState } from 'react';
import { KeyRound, Loader2 } from 'lucide-react';

/** Primeira vez neste equipamento: o código vem do backoffice (Lojas → Terminais). */
export function ActivationScreen({ onActivate }: { onActivate: (code: string) => Promise<string | null> }) {
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  return (
    <div className="grid h-full place-items-center p-4">
      <form
        className="surface w-full max-w-md rounded-2xl p-6 shadow-sm"
        onSubmit={async (e) => {
          e.preventDefault();
          setBusy(true);
          setError(await onActivate(code));
          setBusy(false);
        }}
      >
        <img src="/makila-simbolo.svg" alt="" className="mb-4 h-12 w-12" />
        <h1 className="text-2xl font-bold">Activar esta caixa</h1>
        <p className="mt-1 text-muted">
          Escreva o código de activação que aparece no backoffice do Makila POS, em <b>Lojas → Terminais</b>.
          Precisa de internet só agora; depois a caixa vende mesmo sem rede.
        </p>
        <label className="mt-5 block text-sm font-medium" htmlFor="code">Código de activação</label>
        <input
          id="code"
          autoFocus
          autoComplete="off"
          autoCapitalize="characters"
          spellCheck={false}
          inputMode="text"
          placeholder="XXXXX-XXXXX"
          value={code}
          onChange={(e) => setCode(e.target.value.toUpperCase())}
          className="mt-1 h-14 w-full rounded-xl border border-base bg-surface-2 px-4 text-center font-mono text-2xl tracking-widest"
        />
        {error && <p role="alert" className="mt-3 rounded-lg bg-brand-50 p-3 text-sm text-brand-800">{error}</p>}
        <button
          disabled={busy || code.replace(/[^A-Z0-9]/g, '').length < 10}
          className="mt-5 flex h-14 w-full items-center justify-center gap-2 rounded-xl bg-brand-700 text-lg font-semibold text-white disabled:opacity-40"
        >
          {busy ? <Loader2 className="animate-spin" /> : <KeyRound />} Activar
        </button>
      </form>
    </div>
  );
}
